import { forwardRef, type Ref, type SVGProps } from "react";
const IconLaundromatFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M13 10.5a2.5 2.5 0 0 1 5 0c0 .701-.156 1.023-.393 1.271-.303.317-.84.621-1.866 1.05a2.015 2.015 0 0 0-1.241 1.856v.767l-.037.023-11.01 6.834C1.743 23.362 2.495 26 4.507 26h22.78c2.043 0 2.77-2.703 1.004-3.73l-11.77-6.833-.021-.013v-.748a.03.03 0 0 1 .014-.01c1.015-.425 1.915-.861 2.538-1.512.688-.72.948-1.593.948-2.654a4.5 4.5 0 1 0-9 0 1 1 0 1 0 2 0"
    />
  </svg>
);
const ForwardRef = forwardRef(IconLaundromatFilledSVG);
ForwardRef.displayName = "IconLaundromatFilled";
export { ForwardRef as IconLaundromatFilled };
